import { Routes } from './routes';
import { AppThemeProvider, AuthProvider, DrawerProvider } from './shared/contexts';

export const App: React.FC = () => {
    return (
        <AuthProvider>
            <AppThemeProvider>
                <DrawerProvider>
                    <Routes />
                </DrawerProvider>
            </AppThemeProvider>
        </AuthProvider>
    );
};